export const queryKeys = {
  projects: {
    all: ['projects'] as const,
    detail: (projectId: number) => ['projects', projectId] as const,
  },
  vulnerabilities: {
    all: (projectId: number) => ['vulnerabilities', projectId] as const,
  },
  questions: {
    all: (projectId: number) => ['questions', projectId] as const,
  },
  strideThreats: {
    all: (projectId: number) => ['stride-threats', projectId] as const,
  },
  reconDocs: {
    all: (projectId: number) => ['recon-docs', projectId] as const,
    detail: (projectId: number, docId: number) => ['recon-docs', projectId, docId] as const,
  },
  draftDiagrams: {
    all: (projectId: number) => ['draft-diagrams', projectId] as const,
  },
};
